// extracted by mini-css-extract-plugin
export var closeButton = "NewsModal-module--closeButton--6a081";
export var date = "NewsModal-module--date--b5a84";
export var fadeInAnimation = "NewsModal-module--fadeInAnimation--bf463";
export var img = "NewsModal-module--img--f116e";
export var isLoading = "NewsModal-module--isLoading--f583f";
export var layout = "NewsModal-module--layout--dcd50";
export var loaderContainer = "NewsModal-module--loaderContainer--f0363";
export var paragraph = "NewsModal-module--paragraph--54fdc";
export var picture = "NewsModal-module--picture--36920";
export var scrollWrapper = "NewsModal-module--scrollWrapper--68092";
export var slider = "NewsModal-module--slider--379cf";
export var title = "NewsModal-module--title--2c7d7";